// extracted by mini-css-extract-plugin
module.exports = {"hamag":"hamag-module--hamag--2hWnL","hamagCopy":"hamag-module--hamag-copy--2VNjv","hamagLogos":"hamag-module--hamag-logos--HVikO"};